export type Brand<K, T> = K & { __brand: T }

export type Y4M2 = Brand<string, 'YYYYMM'>

export function makeY4M2(s: string): Y4M2 {
    return s as Y4M2
}

export type IdAdmin = Brand<string, 'IdAdmin'>
export function makeIdAdmin(s: string): IdAdmin { return s as IdAdmin }

export type IdUsuario = Brand<string, 'IdUsuario'>
export function makeIdUsuario(s: string): IdUsuario { return s as IdUsuario }

export type IdAtendimento = Brand<string, 'IdAtendimento'>
export function makeIdAtendimento(s: string): IdAtendimento { return s as IdAtendimento }

export type IdConta = Brand<string, 'IdConta'>
export function makeIdConta(s: string): IdConta { return s as IdConta }

export type IdInbox = Brand<string, 'IdInbox'>
export function makeIdInbox(s: string): IdInbox { return s as IdInbox }

export type IdBot = Brand<string, 'IdBot'>
export function makeIdBot(s: string): IdBot { return s as IdBot }

/** ID **interno** de uma Mensagem. */
export type IdMensagem = Brand<string, 'IdMensagem'>
export function makeIdMensagem(s: string): IdMensagem { return s as IdMensagem }

export type IdGrupo = Brand<string, 'IdGrupo'>
export function makeIdGrupo(s: string): IdGrupo { return s as IdGrupo }

export type IdContato = Brand<string, 'IdContato'>
export function makeIdContato(s: string): IdContato { return s as IdContato }

export type IdCanal = Brand<string, 'IdCanal'>
export function makeIdCanal(s: string): IdCanal { return s as IdCanal }

export type IdTemplate = Brand<string, 'IdTemplate'>
export function makeIdTemplate(s: string): IdTemplate { return s as IdTemplate }

export type IdQuadro = Brand<string, 'IdQuadro'>
export function makeIdQuadro(s: string): IdQuadro { return s as IdQuadro }

export type IdEtiqueta = Brand<string, 'IdEtiqueta'>
export function makeIdEtiqueta(s: string): IdEtiqueta { return s as IdEtiqueta }

export type IdAgendamento = Brand<string, 'IdAgendamento'>
export function makeIdAgendamento(s: string): IdAgendamento { return s as IdAgendamento }

export type IdHorarioAtendimento = Brand<string, 'IdHorarioAtendimento'>
export function makeIdHorarioAtendimento(s: string): IdHorarioAtendimento { return s as IdHorarioAtendimento }

export type IdDataEspecial = Brand<string, 'IdDataEspecial'>
export function makeIdDataEspecial(s: string): IdDataEspecial { return s as IdDataEspecial }

export type IdUsuarioAtendimento = Brand<string, 'IdUsuarioAtendimento'>
export function makeIdUsuarioAtendimento(s: string): IdUsuarioAtendimento { return s as IdUsuarioAtendimento }

export type IdUsuarioCanal = Brand<string, 'IdUsuarioCanal'>
export function makeIdUsuarioCanal(s: string): IdUsuarioCanal { return s as IdUsuarioCanal }

export type IdUsuarioInbox = Brand<string, 'IdUsuarioInbox'>
export function makeIdUsuarioInbox(s: string): IdUsuarioInbox { return s as IdUsuarioInbox }

export type IdWebhook = Brand<string, 'IdWebhook'>
export function makeIdWebhook(s: string): IdWebhook { return s as IdWebhook }

export type IdApiKey = Brand<string, 'IdApiKey'>
export function makeIdApiKey(s: string): IdApiKey { return s as IdApiKey }

export type IdCampanha = Brand<string, 'IdCampanha'>
export function makeIdCampanha(s: string): IdCampanha { return s as IdCampanha }

export type IdNovidade = Brand<string, 'IdNovidade'>
export function makeIdNovidade(s: string): IdNovidade { return s as IdNovidade }
